import { useState } from "react";
import classNames from "classnames";
import { PlusOutlined as Plus24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/PlusOutlined";
import { MinusOutlined as Minus24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/MinusOutlined";
import { TertiaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { sanitiseTerms } from "@/utils/product/sanitiseTerms";

import styles from "./TermsAndConditionsAccordion.module.scss";

type TermsAndConditionsAccordionProps = {
  terms: string;
  isGiftWithPurchaseEnabled?: boolean;
};

const TermsAndConditionsAccordion = ({
  terms,
  isGiftWithPurchaseEnabled = false,
}: TermsAndConditionsAccordionProps) => {
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false);

  const sanitisedTerms = sanitiseTerms(terms);

  return (
    <div className={styles.termsAndConditions}>
      <TertiaryButton
        className={
          isGiftWithPurchaseEnabled
            ? styles.newTermsAndConditionsButtonGiftWithPurchase
            : styles.termsAndConditionsButton
        }
        IconComponent={
          accordionOpen ? Minus24PxOutlinedIcon : Plus24PxOutlinedIcon
        }
        iconPositionRight
        onClick={() => {
          setAccordionOpen(!accordionOpen);
        }}
        data-testid="special-offers-drawer-terms-accordion-button"
        small
        variant="filled-light"
      >
        Terms and conditions apply
      </TertiaryButton>
      {accordionOpen && (
        <div
          data-testid="special-offers-drawer-terms-accordion-content"
          className={classNames(styles.accordion)}
          dangerouslySetInnerHTML={{
            __html: sanitisedTerms,
          }}
        ></div>
      )}
    </div>
  );
};

export default TermsAndConditionsAccordion;
